
import {defineComponent} from 'vue';
import {userResetPwTokenURL} from "@/config/app-settings";
import axios from "axios";
import InputText from "primevue/inputtext";
import Card from "primevue/card";
import Button from "primevue/button";
import Message from "primevue/message";

export default defineComponent({
  name: 'ResetPwResetToken',
  components: {
    Button, Card, InputText, Message
  },
  data() {
    return {
      stateSubmitted: false,
      email: '',
      newPassword: '',
      resetToken: '',
      httpStatus: -1
    }
  },
  computed: {
    fieldsEmpty(): boolean {
      return this.email.length == 0 || this.newPassword.length == 0 || this.resetToken.length == 0;
    }
  },
  methods: {
    resetPwToken() {
      axios.post(userResetPwTokenURL, {
        email: this.email,
        newPassword: this.newPassword,
        resetToken: this.resetToken
      }).then(res => {
        this.stateSubmitted = true;
        this.httpStatus = res.status;
      }).catch(err => {
        this.stateSubmitted = false;
        this.httpStatus = err.response.status;
      })
    },
    toLogin() {
      this.$emit('login')
      this.$router.push({name: 'Login'});
    },
  }
});
